import "allotment/dist/style.css";
import "./invoiceediting.scss";

import { Allotment } from "allotment";
import React from "react";

import { Case, CaseElse, Switch, useWindowDimensions } from "@app/contexts";
import { useFxSelector } from "@app/statefx";
import { schema } from "@app/statefx/schema";
import { EUIIMainSOT } from "@app/statefx/schema/uiInvoiceMain.def";

import { IESideTree } from "./ieSideTree";

export const InvoiceEditMain = () => {
  const { selectedRightTab } = useFxSelector(schema.uiSpvGrid.select);
  const uiInvoiceSettings = useFxSelector(schema.uiInvoiceOverall.select);
  const {
    height: fullHeight,
    headersFooters,
    width,
    rightReserved,
  } = useWindowDimensions();
  const oneQuarter = (width - rightReserved) / 4;

  return (
    <div
      id={"invoiceEditMainPage"}
      style={{ height: `${fullHeight - headersFooters}px` }}
    >
      <Allotment snap>
        <Allotment.Pane
          key={"grid"}
          minSize={oneQuarter}
          prefferedSize={"50%"}
          snap={false}
        >
          <div id={"invoiceEditing"}>
            <div id={"ieTreeToolbarCorner"}>corner</div>
            <div id={"ieTollbar"}>toolbar</div>
            <div id={"ieTree"}>
              <IESideTree />
            </div>

            <div id={"invoiceEditingForm"}>form</div>
          </div>
        </Allotment.Pane>
        <Allotment.Pane
          key={"forms"}
          minSize={Math.max(500, oneQuarter)}
          snap={false}
        >
          <div className="invoice-preview-container" style={{ height: "100%" }}>
            {/* Invoice Preview: A div that scales proportionally with the pane */}
            <div className="invoice-preview-content">{/* Content here */}</div>
          </div>
        </Allotment.Pane>
      </Allotment>
    </div>
  );
};
